export default "__VITE_ASSET__Dl88bDIy__"